export * from './IEscolaridade'
export * from './IExtracao'
export * from './IFiltrosProjeto'
export * from './IGeoLocalizacao'
export * from './ILayoutExtracao'
export * from './ILevantamentoQuantitativo'
export * from './IListaCEP'
export * from './IListaDeduplicacao'
export * from './IOcupacao'
export * from './IPessoaFisica'
export * from './IProcesso'
export * from './IProjeto'
export * from './IRecorteExtração'
export * from './IRelatorioProjeto'
export * from './IRelatorioQuantitativo'
export * from './IStatusProcesso'
export * from './ITamanhoProcesso'
export * from './ITipoProcesso'